<template>
  <div class="home">
    <div class="mt-5 pt-3">
      <h1>Dashboard</h1>
    </div>
    <waiting v-if="loading"/>
    <snackbar :text="text" v-if="text"/>

    <v-container style="padding-left:0;padding-right:0;">
      <v-layout wrap fill-height class="mb-3">
        <v-flex xs10 sm6 md4 lg4 offset-xs1 offset-sm3 offset-md4 offset-lg4>
          <balance @loading="loading = $event"/>
        </v-flex>
        <chart @loading="loading = $event" @text="text = $event"/>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Chart from '@/components/v2/Chart.vue'
import Balance from '@/components/v2/Balance.vue'
import Snackbar from '@/components/Snackbar.vue'
import Waiting from '@/components/Waiting'
import { mapState } from 'vuex'

export default {
  name: 'Home',
  computed: {
    ...mapState([
      'username'
    ])
  },
  components: {
    Chart,
    Balance,
    Snackbar,
    Waiting
  },
  data: () => ({
    text: null,
    loading: true,
    show: false
  }),
  watch: {
    text () {
      setTimeout(() => {
        this.text = null
      }, 5000)
    }
  }
}
</script>
